<template>
	<v-app-bar fixed app height="65" style="width: auto;">
        <!-- >>> Drawer -->
        <v-btn
            style="margin-left: 5px !important"
            depressed
            elevation="1"
            min-width="0"
            @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)">
            <v-icon v-if="value">
                mdi-view-quilt
            </v-icon>

            <v-icon v-else>
                mdi-dots-vertical
            </v-icon>
        </v-btn>
        <!-- <<< Drawer -->


		<v-toolbar-title class="hidden-sm-and-down">
        SunFlight - Blocktimes
        </v-toolbar-title>


		<!-- >>> Filter TextField -->
		<v-combobox
            v-model="input_departureAirport"
			:items="get_Airports"
            item-text="iataCode"
            item-value="iataCode"
            prepend-icon="mdi-airplane-takeoff"
            clearable
			label="Departure Airport"
            style="margin-left:30px;margin-top:30px;"
			@input="onChange_departureAirport(), onClick_setFilter()" />
		<!-- <<< Filter TextField -->
        <!-- >>> Filter TextField -->
		<v-combobox
            v-model="input_destinationAirport"
			:items="get_Airports"
            item-text="iataCode"
            item-value="iataCode"
            prepend-icon="mdi-airplane-landing"
            clearable
			label="Destination Airport"
            style="margin-top:30px;"
			@input="onChange_destinationAirport(), onClick_setFilter()" />
		<!-- <<< Filter TextField -->


		<span style="margin-left: 30px; margin-top: 20px;"><strong>Shown Blocktimes: {{ get_Blocktimes_Filtered.length }}</strong></span>


		<v-spacer />


        <!-- >>> Comes later ... -->
		<v-btn raised elevation="1" min-width="0" text style="margin-left: 40px; margin-right: 0px;">
			<v-icon color="primary">
				mdi-overscan
			</v-icon>
		</v-btn>
        <!-- <<< Comes later ... -->
	</v-app-bar>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters, mapActions } from 'vuex';


	export default {
		name: 'FlightsAppBar',

        /* >>> *************************************************************** / /* Props */
        props: {

            value: {
                type: Boolean,
                default: false
            }

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                // >>> ------------------------------------
                input_departureAirport: '',
                input_destinationAirport: ''
            };

        }, // eo funtion data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_Blocktimes_Filtered',
                'get_Airports'
            ])

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

			...mapActions([
				'actn_set_filterBlocktimes_filterTerm' // save
			]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
           /*******************************************************************
            * onChange_departureAirport()
            *
            * Desc: Use Combobox Input to find the corresponding airport-object.
            * Note: Reset if no airport-object fits the input.
            * Note: Replace the Input with the airport-object if found.
            * Note: After colleciton the airport-object trigger
            * Note: onChange-Prop-Function.
            *
            */
            onChange_departureAirport: function() {

                const me = this;
                let airport;


                me.$toc('>>> views/flights/blocktimes/components/core/AppBar.vue >>> onChange_departureAirport');
                if (Vue.prototype.$isEmpty(me.input_departureAirport)) {
                    me.input_departureAirport = null;	// clear button pressed -> reset state
                    return;
                }

                // comboboxFillAirport
                // if input is object -> we have already found an airport-object
                // if input is not object -> we need to find an airport-object
                if (typeof me.input_departureAirport !== 'object') {
                    airport = me.get_Airports.find(airport => airport.iataCode === me.input_departureAirport.toUpperCase());
                } else {
                    airport = me.get_Airports.find(airport => airport.iataCode === me.input_departureAirport.iataCode.toUpperCase());
                }

                // if airport-object found -> set as "new" input
                // if airport-object not found -> "reset" input
                if (airport !== undefined) {
                    me.input_departureAirport = airport.iataCode;
                } else {
                    me.input_departureAirport = null;
                }

            }, // eo function onChange_departureAirport()

            /*******************************************************************
            * onChange_destinationAirport()
            *
            * Desc: Use Combobox Input to find the corresponding airport-object.
            * Note: Reset if no airport-object fits the input.
            * Note: Replace the Input with the airport-object if found.
            * Note: After colleciton the airport-object trigger
            * Note: onChange-Prop-Function.
            *
            */
            onChange_destinationAirport: function() {

                const me = this;
                let airport;


                me.$toc('>>> views/flights/blocktimes/components/core/AppBar.vue >>> onChange_destinationAirport');
                if (Vue.prototype.$isEmpty(me.input_destinationAirport)) {
                    me.input_destinationAirport = null;	// clear button pressed -> reset state
                    return;
                }
                // comboboxFillAirport
                // if input is object -> we have already found an airport-object
                // if input is not object -> we need to find an airport-object
                if (typeof me.input_destinationAirport !== 'object') {
                    airport = me.get_Airports.find(airport => airport.iataCode === me.input_destinationAirport.toUpperCase());
                } else {
                    airport = me.get_Airports.find(airport => airport.iataCode === me.input_destinationAirport.iataCode.toUpperCase());
                }

                // if airport-object found -> set as "new" input
                // if airport-object not found -> "reset" input
                if (airport !== undefined) {
                    me.input_destinationAirport = airport.iataCode;
                } else {
                    me.input_destinationAirport = null;
                }

            }, // eo function onChange_destinationAirport()

            /*******************************************************************
            * onClick_setFilter()
            *
            * Desc: Sets Filter Term into state
            * Note:
            *
            */
			onClick_setFilter: function(event) {

                const me = this;
                let payload = {};


                me.$toc('>>> views/flights/blocktimes/components/core/AppBar.vue >>> onClick_setFilter');
                payload = {
                    departureAirport: me.input_departureAirport,
                    destinationAirport: me.input_destinationAirport
                };
                me.actn_set_filterBlocktimes_filterTerm(payload);

            } // eo function onClick_setFilter()

        } // eo methods{}
        /* <<< ****************************************************************/
	};
</script>

<style scoped>
	.theme--light.v-app-bar.v-toolbar.v-sheet {
		background-color: #FFFFFF;
		border-color: #FFFFFF;
		color: rgba(0, 0, 0, 0.87);
	}

	.v-toolbar__title {
		font-weight: 300;
		color: #555555;
		font-size: 18px;
		margin-bottom: 0px;
	}

	.theme--light.v-btn.v-btn--has-bg {
		background-color: #fff;
	}

    .v-label {
        font-size: 14px !important; /* 16px */
    }

    .sdr-custom-text-input input {
        text-transform: uppercase;
    }

</style>

<style>
    .sdr-custom-button-with-icon .v-icon::before {
        color: #AB3B7A;
    }

    .sdr-custom-button-with-icon.v-btn--disabled .v-icon::before {
        color: #e0e0e0;
    }

    .v-slider__tick, .v-slider__tick.v-slider__tick--filled {
        width: 7px !important;
        height: 7px !important;
        border-radius: 50%;
        margin-top: -3px;
        margin-left: -3px;
        background: #AB3B7A;
        cursor: pointer;
    }

    .v-slider__tick:first-of-type .v-slider__tick-label {
        transform: translateX(-50%) !important;
    }

    .v-slider__tick:last-of-type .v-slider__tick-label {
        transform: translateX(-25%) !important;
    }

    .theme--light.v-label {
		color: rgba(0, 0, 0, 0.7);
	}
</style>
